// Stellarium Web - Copyright (c) 2018 - Noctua Software Ltd
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>
  <v-card v-if="selectedObject" transparent style="background: rgba(66, 66, 66, 0.7);">
    <v-btn icon style="position: absolute; right: 0" v-on:click.native="unselect()"><v-icon>mdi-close</v-icon></v-btn>
    <v-card-title primary-title>
      <div style="width: 100%">
        <img :src="icon" height="48" width="48" align="left" style="margin-top: 3px; margin-right: 10px"/>
        <div style="overflow: hidden; text-overflow: ellipsis;">
          <div class="text-h5">{{ title }}</div>
          <div class="grey--text text-body-2">{{ type }}</div>
        </div>
      </div>
    </v-card-title>
    <template slot="progress">
      <v-progress-linear color="teal" height="25" indeterminate></v-progress-linear>
    </template>
    <a v-if="ioniaImg" :href="ioniaImgUrl" target="_blank">
      <v-img :src="ioniaImg"></v-img>
    </a>
  </v-card>
</template>

<script>

import swh from '@/assets/sw_helpers.js'
// import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  data: function () {
    return {
      showMinorNames: false,
      copied: false,
      ioniaImg: null, // ionia image URL
      ioniaImgUrl: null // ionia image link
    }
  },
  computed: {
    ...mapGetters(['IOStars']),
    selectedObject: function () {
      return this.$store.state.selectedObject
    },
    stelSelectionId: function () {
      return this.$store.state.stel && this.$store.state.stel.selection ? this.$store.state.stel.selection : undefined
    },
    title: function () {
      return this.selectedObject ? this.otherNames[0] : 'Selection'
    },
    otherNames: function () {
      return this.selectedObject ? swh.namesForSkySource(this.selectedObject, 26) : undefined
    },
    type: function () {
      if (!this.selectedObject) return this.$t('Unknown')
      let morpho = ''
      if (this.selectedObject.model_data && this.selectedObject.model_data.morpho) {
        morpho = swh.nameForGalaxyMorpho(this.selectedObject.model_data.morpho)
        if (morpho) {
          morpho = morpho + ' '
        }
      }
      return morpho + swh.nameForSkySourceType(this.selectedObject.types[0])
    },
    icon: function () {
      return swh.iconForSkySource(this.selectedObject)
    },
    extraButtons: function () {
      return swh.selectedObjectExtraButtons
    }
  },
  watch: {
    selectedObject: function (s) {
      this.showMinorNames = false
      this.ioniaImg = null
      this.ioniaImgUrl = null
      this.getIoniaImg()
    },
    stelSelectionId: function (s) {
      if (!this.$stel.core.selection) {
        this.$store.commit('setSelectedObject', 0)
        return
      }
      swh.sweObj2SkySource(this.$stel.core.selection).then(res => {
        this.$store.commit('setSelectedObject', res)
      }, err => {
        console.log("Couldn't find info for object " + s + ':' + err)
        this.$store.commit('setSelectedObject', 0)
      })
    }
  },
  methods: {
    async getIoniaImg () {
      var vm = this
      var selectedShortName = vm.selectedObject.short_name
      const s = await this.IOStars

      for (var ios of s) {
        if (ios.star.toLowerCase().includes(selectedShortName.toLowerCase())) {
          vm.ioniaImg = ios.image_url
          vm.ioniaImgUrl = ios.image_link
          break
        }
      }
    },

    unselect: function () {
      this.$stel.core.selection = 0
    },
    stopZoom: function () {
      if (this.zoomTimeout) {
        clearTimeout(this.zoomTimeout)
        this.zoomTimeout = undefined
      }
    },
    ...mapActions(['fetchData'])
  },
  mounted: function () {
    const that = this
    window.addEventListener('mouseup', function (event) {
      that.stopZoom()
    })
  },
  created: function () {
    this.fetchData()
  }
}
</script>

<style>
a {
  height: 100%;
  width: 100%;
}
</style>
